export default __webpack_public_path__ + "static/media/tape_type.55f34ff2.jpeg";